import { paths } from "app/paths";

/*
 * Rotas onde estar deslogado é o normal, e não sessão expirada.
 *
 * A lista existia só dentro do App, para decidir o que renderizar. O
 * interceptor do axios não tinha nenhuma, então tratava todo 401 como sessão
 * caída — inclusive o 401 que o `/me` devolve para quem abre o site pela
 * primeira vez e cai na Sobre. Com uma fonte só, publicar uma página aberta
 * nova passa a valer nos dois lugares de uma vez.
 */
export const ROTAS_PUBLICAS = [
  "/",
  "/sobre",
  "/login",
  "/cadastro",
  "/privacy-policy",
  "/shopify-install",
  paths.nuvemshopConectado,
  paths.nuvemshopEmbedded,
];

/*
 * O admin tem autenticação própria (AdminAuthContext), e a página de status e
 * a doc de API são abertas: um 401 da sessão de cliente em qualquer uma delas
 * não quer dizer que alguém precise entrar como cliente.
 */
export function ehRotaPublica(pathname: string): boolean {
  return (
    ROTAS_PUBLICAS.includes(pathname) ||
    pathname.startsWith("/admin") ||
    pathname === paths.status ||
    pathname === paths.apiDocs
  );
}
